document.addEventListener('DOMContentLoaded', function () {
  const accordionTriggers = document.querySelectorAll('.accordion-trigger');
  if (!accordionTriggers.length) return;

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      this.classList.toggle('active');
      const content = this.nextElementSibling;

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';

        if (window.innerWidth <= 768) {
          setTimeout(() => {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        }
      }
    });
  });

  const mobileGuide = document.querySelector('.size-chart-mobile-guide');
  if (mobileGuide) {
    const updateMobileGuide = () => {
      mobileGuide.style.display = window.innerWidth <= 768 ? 'block' : 'none';
    };

    updateMobileGuide();
    window.addEventListener('resize', updateMobileGuide);
  }
});
